module.exports = __webpack_public_path__ + "assets/img/tag_list-a6647fdc.png";